<template>
  <div
    v-if="visible"
    role="status"
    class="fixed inset-0 bg-ink-950/60 backdrop-blur-[2px] flex items-center justify-center z-50"
  >
    <div class="glass p-6 flex flex-col items-center space-y-4">
      <div class="relative w-10 h-10">
        <svg class="w-full h-full compass-spin" viewBox="0 0 40 40" fill="none">
          <circle cx="20" cy="20" r="17.5" stroke="rgba(20,26,44,0.12)" stroke-width="1.5"/>
          <path d="M20 3.5 L23 12 L20 20 L17 12 Z" fill="#5e3d91"/>
          <circle cx="20" cy="20" r="2" fill="#1a2138"/>
        </svg>
      </div>
      <p class="text-ink-800 font-medium text-sm">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoadingOverlay",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Cargando...",
    },
  },
});
</script>

<style scoped>
.compass-spin {
  animation: compass-sweep 1.1s cubic-bezier(0.65, 0, 0.35, 1) infinite;
  transform-origin: center;
}

@keyframes compass-sweep {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
